import DeviceService from "../../services/Device"
import ServiceCaller from "../../services/ServiceCaller"

const service = new DeviceService()

const state = {
  error: "ZZZZ",
  inProgress: false,
  devices: null,
  deviceDetails: {},
  selectedDevice: null,
  locationHistoryEPS: 0.1,
  locationHistoryMCS: 5,
  updateResponse: null,
  updateError: "",
  connectResponse: null,
  connectError: "",
  instructionResponse: null,
  instructionError: "",
  addDeviceResponse: null,
  unshareDeviceResponse: null,
}

const mutations = {
  setError: (state, value) => {state.error = value},
  setInProgress: (state, value) => {state.inProgress = value},
  setDevices: (state, value) => {state.devices = value},
  setDeviceDetails: (state, value) => {state.deviceDetails = value},
  setSelectedDevice: (state, value) => {state.selectedDevice = value},
  setLocationHistoryEPS: (state, value) => {state.locationHistoryEPS = value},
  setLocationHistoryMCS: (state, value) => {state.locationHistoryMCS = value},
  setUpdateResponse: (state, value) => {state.updateResponse = value},
  setUpdateError: (state, value) => {state.updateError = value},
  setConnectResponse: (state, value) => {state.connectResponse = value},
  setConnectError: (state, value) => {state.connectError = value},
  setInstructionResponse: (state, value) => {state.instructionResponse = value},
  setInstructionError: (state, value) => {state.instructionError = value},
  setAddDeviceResponse: (state, value) => {state.addDeviceResponse = value},
  setUnshareDeviceResponse: (state, value) => {state.unshareDeviceResponse = value}
}

const getters = {
  // userToken (state, getters, rootState) {}
  needForBilling: (state) => {
    for (let index in state.devices) {
      if (!state.devices[index].NonBillable) {
        return true
      }
    }
    return false
  },
}

const actions = {
  loadDevices: (context) => ServiceCaller.call(service.listUserDevices(), context.commit, 'setDevices', 'setError', 'setInProgress'),
  loadDeviceDetails: (context) => ServiceCaller.call(service.loadDeviceDetails((context.state.selectedDevice || {}).ID, context.state.locationHistoryEPS, context.state.locationHistoryMCS), context.commit, 'setDeviceDetails', 'setError','setInProgress'),
  update: (context, payload) => ServiceCaller.call(service.updateDevice(context.state.selectedDevice.ID, payload), context.commit, 'setUpdateResponse', 'setUpdateError', 'setInProgress', true),
  connect: (context) => ServiceCaller.call(service.connectToDevice(context.state.selectedDevice.ID, "CONNECT"), context.commit, 'setConnectResponse', 'setConnectError', 'setInProgress', true),
  instruction: (context, payload) => ServiceCaller.call(service.sendInstruction(context.state.selectedDevice.ID, payload), context.commit, 'setInstructionResponse', 'setInstructionError', 'setInProgress', true),
  addDevice: (context, payload) => ServiceCaller.call(service.addDevice(payload), context.commit, 'setAddDeviceResponse', 'setError', 'setInProgress', true),
  unshareDevice: (context, payload) => ServiceCaller.call(service.unshareDevice(payload), context.commit, 'setUnshareDeviceResponse', 'setError', 'setInProgress', true),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

